import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const ErrorInfoIconWrapper = styled.div`
  width: 14px;
  height: 14px;
  color: ${COLORS.primary_light_blue};
  .img,
  svg {
    vertical-align: text-top;
  }
`;
